import type { JsonObject } from "~/common/types/graphql.scalars";
import type { GetCategoriesWithPropertiesQuery } from "~/features/dataImportProjects/gqls";

import {
  type SchemaDesignerEntityCategory,
  type SchemaDesignerRelationCategory,
  type SchemaDesignerSourceTargetCategory,
  zCategoryID,
} from "./types";

export const SchemaDesignerCategoryMapper = {
  sourceTargetCategory: {
    toModel: (dto: {
      id: string;
      name: string;
      i18nLabel?: JsonObject | null;
    }): SchemaDesignerSourceTargetCategory => ({
      id: zCategoryID.parse(dto.id),
      name: dto.name,
      i18nLabel: dto.i18nLabel,
    }),
  },

  categoryCandidate: {
    entity: {
      toModel: (cat: GetCategoriesWithPropertiesQuery["categories"][number]): SchemaDesignerEntityCategory => ({
        id: zCategoryID.parse(cat.id),
        name: cat.name,
        i18nLabel: cat.i18nLabel,
        type: "entity" as const,
        properties: cat.categoryPropertySchemaSet?.[0]?.propertySchemaSet?.propertySchemaAssociations || [],
        metadata: [],
      }),
    },
    relation: {
      toModel: (cat: GetCategoriesWithPropertiesQuery["categories"][number]): SchemaDesignerRelationCategory | null => {
        if (!cat.relationType) {
          return null;
        }

        return {
          id: zCategoryID.parse(cat.id),
          name: cat.name,
          i18nLabel: cat.i18nLabel,
          type: "relation" as const,
          properties: cat.categoryPropertySchemaSet?.[0]?.propertySchemaSet?.propertySchemaAssociations || [],
          metadata: [],
          relationType: {
            sourceCategory: SchemaDesignerCategoryMapper.sourceTargetCategory.toModel(cat.relationType.sourceCategory),
            targetCategory: SchemaDesignerCategoryMapper.sourceTargetCategory.toModel(cat.relationType.targetCategory),
          },
        };
      },
    },
  },
};
